module.exports = __webpack_public_path__ + "img/prospect-new.f2805365.png";